import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationType } from "modules/common";

interface ModuleUsageLog {
    moduleUsageType: number;
    applicationSourceType: ApplicationType;
}

interface State {
    isLoading: boolean;
    fetchError: boolean;
    fetchSuccess: boolean;
    errorMessage: string | undefined;
    data: ModuleUsageLog | null;
}

interface CreateModuleUsageLogSuccess {
    data: ModuleUsageLog;
}

interface GetModuleUsageLogError {
    errorMessage: string;
}

const initialState: State = {
    isLoading: false,
    fetchError: false,
    fetchSuccess: false,
    errorMessage: undefined,
    data: null,
};

const moduleUsageLogSlice = createSlice({
    name: "ModuleUsageLog",
    initialState: initialState,
    reducers: {
        createModuleUsageLogSuccess: (
            state,
            action: PayloadAction<CreateModuleUsageLogSuccess>
        ) => {
            state.isLoading = false;
            state.fetchSuccess = true;
            state.data = action.payload.data;
        },
        createModuleUsageLogError: (state, action: PayloadAction<GetModuleUsageLogError>) => {
            state.isLoading = false;
            state.fetchError = true;
            state.errorMessage = action.payload.errorMessage;
        },
    },
});

const { actions } = moduleUsageLogSlice;
export const { createModuleUsageLogError, createModuleUsageLogSuccess } = actions;
export const moduleUsageLogReducer = moduleUsageLogSlice.reducer;
